import React, { useEffect, useMemo } from 'react';
import DisabledChatInfo from '../SupportTrack/DisableChatInfo';
import RenderChatMessages from '../chat/ChatMessage';
import { isMobileView } from '../../utils/utils';
import { getChatById } from '../../actions/chat';
import { useDispatch, useSelector } from 'react-redux';
import { GetQueryParam, isLogged } from '../../utils/common';
import { RenderBasicInfo, RenderContactInfo } from './Details';

export const Chats = ({ closeIconClick }) => {
    const supportTrackServiceRequestError = useSelector((state) => state.serviceRequest.supportTrackServiceRequestError);
    const newLoggedUserData = useSelector((state) => state.auth.newLoggedUserData);
    const ticketId = GetQueryParam('ticketId');
    const redirectTo = GetQueryParam('redirectTo');

    const isUserLoggedIn = isLogged() && newLoggedUserData;
    const dispatch = useDispatch();
    const supportTrackServiceRequest = useSelector((state) => state.serviceRequest.supportTrackServiceRequest);

    const memoizedTicketDetails = useMemo(() => {
        let details = {};
        if (supportTrackServiceRequest) details = supportTrackServiceRequest;
        return details;
    }, [supportTrackServiceRequest]);

    useEffect(() => {
        if (ticketId) {
            dispatch(getChatById({ id: ticketId }));
        }
    }, [ticketId, dispatch]);

    const { chat, detail } = useMemo(() => {
        let d = true;
        let c = true;
        if (isMobileView && redirectTo === 'chat') {
            c = true;
            d = false;
        } else if (isMobileView && redirectTo === 'detail') {
            c = false;
            d = true;
        }
        return { chat: c, detail: d }
    }, [redirectTo]);

    if (!isUserLoggedIn || !ticketId) {
        return <DisabledChatInfo ticketId={ticketId} />
    }

    return <>
        {chat ? <RenderChatMessages showChatHeader={!isMobileView} mainDivClass='overflow-hidden chat-card-wtih-edit-ticket' noTicketFound={supportTrackServiceRequestError} ticketId={ticketId} onTicketModalSearchCancel={closeIconClick} isUserLoggedIn={isUserLoggedIn} showTicketSearch isSupportTicket chat_id={ticketId} /> : null}
        {detail ? <div className='edit-ticket-card-wtih-chat bg-scogolightblue flex h-full p-4 gap-4' style={{
            flexFlow: 'column',
        }}>
            <RenderContactInfo memoizedTicketDetails={memoizedTicketDetails} />
            <RenderBasicInfo serviceRequest={memoizedTicketDetails} />
        </div> : null
        }
    </>
};